import styled from 'styled-components'
import React from 'react'

const ButtonSpinnerWrapper = styled.span`
  display: inline-block;
  margin-left: 12px;
  height: 18px;
`

export const ButtonSpinner = () => {
  return (
    <ButtonSpinnerWrapper>
      <i className='fa fa-spinner fa-spin' />
    </ButtonSpinnerWrapper>
  )
}
